<template>
    <div>
        <div class="d-flex-center py-5">
            <img
                src="@/assets/report/quarterly.png">
        </div>
        <v-container>
            <v-row>
                <v-col
                    class="pb-0"
                    offset="3"
                    cols="6">
                    <v-container>
                        <v-row>
                            <v-col
                                offset="2"
                                cols="4">
                                <v-select
                                    v-model="quarter"
                                    :items="quarterList"
                                    item-text="text"
                                    item-value="value"
                                    label="Quarter">
                                </v-select>
                            </v-col>
                            <v-col
                                cols="4">
                                <v-menu
                                    ref="menu"
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            slot="activator"
                                            v-model="displayYear"
                                            label="Year"
                                            prepend-inner-icon="event"
                                            @click:prepend-inner="menu = true"
                                            v-on="on"
                                            readonly>
                                        </v-text-field>
                                    </template>
                                    <v-date-picker
                                        ref="picker"
                                        :locale="localeLang"
                                        v-model="year"
                                        :max="maxDate"
                                        @input="save"
                                        reactive
                                        no-title>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>

                <v-col
                    class="d-flex-center pt-0"
                    offset="4"
                    cols="4">
                    <v-btn
                        color="primary"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="genQuarterlyReport">
                        export
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'Quarter',

    props: {
        canGenReport: {
            type: Boolean,
            default: false
        },
        branchId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            quarterList: [
                {
                    text: 'Quarter 1',
                    value: 'Q1'
                },
                {
                    text: 'Quarter 2',
                    value: 'Q2'
                },
                {
                    text: 'Quarter 3',
                    value: 'Q3'
                },
                {
                    text: 'Quarter 4',
                    value: 'Q4'
                }
            ],
            quarter: 'Q1',
            date: null,
            menu: false,
            year: this.$util.getCurrentDate(),
            maxDate: this.$util.getCurrentDate(),
            displayYear: this.yearFormat(this.$util.getCurrentDate())
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        }
    },

    methods: {
        save (date) {
            this.$refs.menu.save(date)
            this.$refs.picker.activePicker = 'YEAR'
            this.menu = false
        },

        yearFormat (yearPick) {
            const [year] = yearPick.split('-')
            const BEYear = parseInt(year) + 543
            return `${BEYear}`
        },

        async genQuarterlyReport () {
            this.$store.dispatch('setLoading', true)
            const [, quarter] = this.quarter.split('Q')
            this.axios.post('report/quarter', { year: parseInt(this.year), quarter: parseInt(quarter), branch_id: this.branchId }, {
                headers: {
                    'Content-Type': 'application/pdf'
                },
                responseType: 'arraybuffer'
            }).then((response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' })
                const url = window.URL.createObjectURL(blob)

                this.$store.dispatch('setLoading', false)
                window.open(url)
            }).catch((error) => {
                this.error = error
            })
        }
    },

    watch: {
        menu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
        'year' () {
            this.displayYear = this.yearFormat(this.year)
        }
    }
}
</script>

<style lang="scss" scoped>
.layout-row {
    display: flex;
    justify-content: space-around;
    align-items: center;
}
</style>
